<div class="list" [ngClass]="'list--' + listType">
  <!-- Child items -->
  <ng-content select="app-list-item"></ng-content>
</div>
